<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <h3 class="headline mt-0">
          <img src="/static/img/akita.png" style="max-height: 50px" />
        </h3>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <template v-if="$store.getters.getPackage == 'premium'">
          <v-btn fab outline small color="primary" v-if="!isEdit" @click="editAkita">
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn readonly fab outline small color="grey" v-on="on">
                <v-icon>lock</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}</span>
          </v-tooltip>
        </template>
      </v-flex>
    </v-layout>
    <div v-if="loading" class="spinner text-xs-center">
      <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
    </div>
    <template v-else>
      <div
        class="pa-2"
        style="position: relative; "
        :style="{ 'min-height': !check_privilege('akita') ? '' : '' }"
      >
        <!-- <v-premium-plan-popup
          v-if="!check_privilege('akita')"
          type="premium"
          text="Upgrade to premium, starting at 500 baht / month to connect ZWIZ with AKITA Upgrade now."
        ></v-premium-plan-popup> -->
        <div class="mb-2" v-if="token != null">
          <div>
            {{ $t('เปิด/ปิด การใช้งาน Akita') }}
          </div>
          <div>
            <toggle-button
              class="mt-2"
              :value="status"
              :sync="true"
              :color="$vuetify.theme.success"
              @change="toggleStatus"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
            />
          </div>
        </div>

        <!-- <div class="mb-2">
          <div>
            {{ $t('Set up channel') }}
          </div>
          <div>
            <template v-if="isEdit">
              <v-select
                v-model="url"
                outline
                single-line
                :items="url_list"
                v-validate="'required'"
                :data-vv-as="$t('Set up channel')"
                name="url"
                :error="errors.has('url')"
                :error-messages="errors.first('url')"
              ></v-select>
            </template>
            <div class="primary--text" v-else>
              {{ current_url ? current_url.text : '-' }}
            </div>
          </div>
        </div> -->

        <div class="form-control" :class="{ 'has-error': errors.has('token') }">
          <div class="caption mt-2">Token</div>
          <template v-if="isEdit">
            <input
              type="text"
              v-model="token"
              name="token"
              data-vv-as="Token"
            />
            <span class="text-error" v-if="errors.has('token')">{{ errors.first('token') }}</span>
          </template>
          <div class="primary--text" v-else>
            {{ token ? token : '-' }}
          </div>
        </div>

        <div class="text-xs-center" v-if="isEdit">
          <v-btn color="grey" outline @click="onCancel">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" depressed @click="onSave">
            {{ $t('Save') }}
          </v-btn>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      url: '',
      url_list: [
        {
          text: 'Staging THP',
          value: 'https://staging-thp-portal.akitahub.com'
        },
        {
          text: 'Production THP',
          value: 'https://ffmportal.thailandpost.com'
        },
        {
          text: 'Staging Akita',
          value: 'https://staging-service.akitahub.com'
        },
        {
          text: 'Production Akita',
          value: 'https://service.akitahub.com'
        }
      ],
      isEdit: false,

      loading: false,
      token: null,
      status: false
    }
  },
  async mounted() {
    this.loading = true
    var response = await this.getakita()
    if (response.data && response.data.length > 0) {
      try {
        this.status = response.data[0].akita_status
        if (response.data[0].akita_token) this.token = response.data[0].akita_token
        // if (response.data[0].akita_endpoint_url) this.url = response.data[0].akita_endpoint_url
        let url = ''

        try {
          url = this.url_list.find(el => {
            return response.data[0].akita_endpoint_url == el.value
          })
        } catch (error) {}
        this.url = url || ''
      } catch (error) {}
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    current_url() {
      let url = null

      try {
        url = this.url_list.find(el => {
          return this.url.value == el.value
        })
      } catch (error) {}
      return url || null
    }
  },
  methods: {
    async toggleStatus() {
      var vm = this
      vm.loading = true;
      const status = !vm.status
      try {
        await vm.saveAkita({
          params: {
            pageid: vm.selectedBot.pageid
          },
          body: {
            akita_status: status,
            akita_token: vm.token,
            akita_endpoint_url: vm.url.value
          }
        })
        await this.$store.dispatch('updateBotDetail')
        vm.status = status
      } catch (error) {
        console.log(error)
      }
      vm.loading = false
    },
    getakita() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getakita({ pageid: vm.selectedBot.pageid }, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editAkita() {
      this.isEdit = true
      this.cached_token = this.token
      this.cached_status = this.status
      this.cached_url = this.url
    },
    onCancel() {
      this.isEdit = false
      this.token = this.cached_token
      this.status = this.cached_status
      this.url = this.cached_url
    },
    async saveAkita(data) {
      return new Promise((resolve, reject) => {
        api.saveakita(data, (error, response) => {
          if (error) {
            reject(error)
          }

          resolve(response)
        })
      })
    },
    async onSave() {
      if (!this.check_privilege('akita')) return false
      if (this.token != null && this.status == null) this.status = true
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.loading = true

      try {
        await this.saveAkita({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            akita_status: this.status,
            akita_token: this.token,
            akita_endpoint_url: this.url.value || ''
          }
        })
        await this.$store.dispatch('updateBotDetail')

        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })

        this.cached_token = this.token
        this.cached_status = this.status

        this.isEdit = false
      } catch (error) {}
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/AkitaManage.vue